import { Grid } from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import Slider from "react-slick";
import ClientSettingApiService from "../../adapters/xhr/ClientSettingApiService";
import LineApiService from "../../adapters/xhr/LineApiService";
import { SliderSettings } from "../../Constant";
import MyContext from "../../contexts/MyContext";
import { formatDate, formatTime } from "../../Utils";
import { Slide1 } from "./main-slide/Slide1";
import { Slide2 } from "./main-slide/Slide2";
import { Slide3 } from "./main-slide/Slide3";
import "./PublicPage.scss";

export const PublicPage = (props) => {
  let sliderRef = React.createRef();
  const myContext = useContext(MyContext);

  const fetchLines = useCallback(async () => {
    let response = await LineApiService.getAll();
    if (response) {
      myContext.changeLines(response);
    }
  }, []);

  const getClientAppSettings = useCallback(async () => {
    let response = await ClientSettingApiService.GetAllowedFileExtension();
    myContext.changeAllowFileUploadExtension(response);
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  useEffect(() => {
    getClientAppSettings();
    if (!myContext.lines || myContext.lines.length === 0) fetchLines();
  }, []);

  const fetchDepartureTimeList = async () => {
    let response = await LineApiService.getDepartureTimeList(
      myContext.from.stopNumber,
      myContext.to.stopNumber,
      myContext.line.number,
      formatDate(myContext.departureDate)
    );
    if (response) {
      let data = response.map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  useEffect(() => {
    if (myContext.departureTimeOptions) myContext.changeDepartureTime(null);
  }, [myContext.departureTimeOptions]);

  useEffect(() => {
    if (myContext.departureDate && myContext.from && myContext.to && !myContext.departureTime) {
      if (myContext.line) {
        fetchDepartureTimeList();
        myContext.changeDepartureTime(null);
      }
    }
  }, [myContext.departureDate, myContext.from, myContext.to, myContext.line]);

  const setActiveSlide = (index) => {
    myContext.changeActiveSlide(index);
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="container custom padding top-2 bottom-2 left-0 right-0" justifyContent="center">
          <Grid item>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => setActiveSlide(next)}>
              <Slide1 />
              <Slide2 />
              <Slide3 />
            </Slider>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
